module.exports = __webpack_public_path__ + "static/media/nebulas.6c2ae9af.png";